import styled from 'styled-components';

import { colors } from '../../../utils/utils';

const UserInfoWrapper = styled.div`
    padding: 8px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    color: ${colors.gray.jumbo};
    background-color: ${colors.gray.wild_sand};
    font-size: 11px;
    height: 32px;

    & > span:first-child {
        white-space: nowrap;
    }

    & > span:last-child {
        margin-left: auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: right;
    }
`;

export default UserInfoWrapper;
